import { Component, OnInit, effect, input, output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductStatus } from '@mira-avant/mtlibs';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { FormTitleComponent } from '../../../ui/forms/form-title/form-title.component';
import { TextFieldComponent } from '../../../fields/standard/text-field/text-field.component';
import { ProductDropdownFieldComponent } from '../../../fields/standard/product-dropdown-field/product-dropdown-field.component';
import { v4 } from 'uuid';

@Component({
	selector: 'app-product-status-form',
	standalone: true,
	imports: [
		AppModule,
		ZorroModule,
		ThirdPartyModule,
		AngularModule,
		FormTitleComponent,
		TextFieldComponent,
		ProductDropdownFieldComponent,
	],
	templateUrl: './product-status-form.html',
	styleUrl: './product-status-form.scss',
})
export class ProductStatusForm implements OnInit {
	public productStatus = input<ProductStatus | undefined | null>();
	public onSubmit = output<ProductStatus>();

	public form: FormGroup = this.fb.group({
		status: ['', [Validators.required, Validators.maxLength(255)]],
		product_name: ['', [Validators.required, Validators.maxLength(255)]],
	});

	constructor(private fb: FormBuilder) {
		effect(() => {
			const productStatus = this.productStatus();
			if (productStatus) {
				this.form.patchValue({
					product_name: productStatus.product_name,
					status: productStatus.status,
				});
			}
		});
	}

	ngOnInit(): void {}

	public async onFormSubmit(): Promise<void> {
		if (this.form.invalid) {
			console.error('Form is invalid', this.form.errors);
			return;
		}

		try {
			const edit: ProductStatus | null | undefined = this.productStatus();

			this.onSubmit.emit({
				uuid: edit?.uuid || v4(),
				status: this.form.value.status || edit?.status || '',
				product_name: this.form.value.product_name || edit?.product_name || '',
				display_order: this.form.value.display_order || edit?.display_order || 0,
				created: edit?.created || new Date(),
				updated: new Date(),
			});
			this.clear();
		} catch (error) {
			console.error('Error submitting form:', error);
		}
	}

	public clear(): void {
		this.form.reset({});
	}
}
